import type { IconName } from "@dms/ui";

export interface NavItem {
  label: string;
  path: string;
  icon: IconName;
}

export interface NavSection {
  heading?: string;
  items: NavItem[];
}

// User SPA sidebar (ClearFlow shell): згруповано за секціями дизайн-системи.
export const NAV_SECTIONS: NavSection[] = [
  { items: [{ label: "Панель", path: "/dashboard", icon: "home" }] },
  {
    heading: "Комунікації",
    items: [{ label: "Чат", path: "/chat", icon: "chat" }],
  },
  {
    heading: "CRM",
    items: [{ label: "Клієнти", path: "/clients", icon: "contacts" }],
  },
  {
    heading: "Документообіг",
    items: [
      { label: "Задачі", path: "/tasks", icon: "tasks" },
      { label: "Процеси", path: "/processes", icon: "layers" },
      { label: "Документи", path: "/documents", icon: "docs" },
      { label: "Проєкти", path: "/projects", icon: "projects" },
      { label: "Бібліотека файлів", path: "/library", icon: "layers" },
      { label: "Архів", path: "/archive", icon: "archive" },
    ],
  },
  {
    heading: "Інструменти",
    items: [
      { label: "Звіти", path: "/reports", icon: "reports" },
      { label: "Пошук", path: "/search", icon: "search" },
      { label: "Довідники", path: "/dictionaries", icon: "book" },
      { label: "Контакти", path: "/contacts", icon: "contacts" },
    ],
  },
  {
    heading: "Підтримка",
    items: [
      { label: "Довідка", path: "/help", icon: "helpCircle" },
      { label: "Runbook інтеграції", path: "/integration-runbook", icon: "book" },
    ],
  },
];

// Плаский список (для маршрутів/плейсхолдерів у App.tsx).
export const NAV_ITEMS: NavItem[] = NAV_SECTIONS.flatMap((s) => s.items);

// Розділи з реальними екранами (решта nav-пунктів лишаються плейсхолдерами).
// Джерело істини — тут (nav), а не в App.tsx: контракт-тест «кожен реалізований
// NAV_ITEM має help-topic» (M20, ADR-042) звіряє довідку саме проти цього набору.
export const IMPLEMENTED_PATHS = new Set<string>([
  "/dashboard",
  "/documents",
  "/tasks",
  "/projects",
  "/processes",
  "/archive",
  "/search",
  "/reports",
  "/contacts",
  "/dictionaries",
  "/clients",
  "/library",
  "/chat",
  "/help",
  "/integration-runbook",
]);
